/**
 * CollectionsPage - Collections overview page for v4 Records
 *
 * Atomic level: Page
 * Displays the collections home view with collections list and saved views
 *
 * Following GO UI Design System patterns
 */

import React from 'react';
import { cn } from '../../../lib/utils';
import { CollectionsHomeTab } from './CollectionsHomeTab';

interface CollectionsPageProps {
  className?: string;
}

/**
 * Collections page - displays collections and saved views
 * Records are always viewed within a specific collection context
 */
const CollectionsPage: React.FC<CollectionsPageProps> = ({ className }) => {
  return (
    <div className={cn('flex h-full min-h-0 flex-col overflow-y-auto bg-[var(--go-spring)] px-4 py-4 sm:px-6 sm:py-6 xl:px-8', className)}>
      <div className="mx-auto flex w-full max-w-[1760px] flex-col gap-6">
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight text-foreground">Monitor Conduct</h1>
          <p className="text-sm text-muted-foreground mt-0.5">
            Continuous detection across your customer feedback
          </p>
        </div>
        <CollectionsHomeTab />
      </div>
    </div>
  );
};

export { CollectionsPage };
export default CollectionsPage;
